import { Column, Entity, JoinColumn, OneToOne, PrimaryGeneratedColumn } from 'typeorm';
import { BaseEntity } from './BaseEntity';
import { IAppointment } from './interface/IAppointment';
import { IVerification } from './interface/IVerification';

@Entity('appointment')
export class Appointment extends BaseEntity implements IAppointment{
  apiMapping = {
    interventionRef: 'interventionRef',
    employeeNumber: 'employeeNumber',
    employeeFullName: 'employeeFullName',
    startDate: 'startDate',
    endDate: 'endDate',
  };

  @PrimaryGeneratedColumn()
  id: number;

  @Column({ nullable: true })
  interventionRef: string;

  @Column({ nullable: true })
  startDate: string;

  @Column({ nullable: true })
  endDate: string;

  @Column({ nullable: true })
  employeeNumber: string;

  @Column({ nullable: true })
  employeeFullName: string;

  @OneToOne('Verification', 'appointment')
  @JoinColumn()
  verification: IVerification;
}
